import Particles from "react-tsparticles";
import particleConfig from "../config/particleConfig";
import { loadFull } from "tsparticles";
import "./Home.css";

const Home = () => {
  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <section id="home">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particleConfig}
      />
      <div className="home-content" data-aos="fade-right">
        <h3>
          Hi,  I'am <br></br>Abhishek <span style={{ color: "#7e57c2" }}>Kumar</span>
        </h3>
        <p className="intro"><span className="intro-text">I am a Full Stack Developer  </span></p>
        <a className="link-btn" href="../../Abhishek_Kumar_Resume.pdf" download>
            Resume &nbsp;&nbsp;<i className="fa-solid fa-download"></i>
        </a>
        <div className="socials">
          <ul className="social-icons">
            <li>
              <a
                href="https://www.linkedin.com/in/abhishek-kumar-30a769200/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-linkedin fa-lg"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/abhishek.ak_/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-instagram fa-lg"></i>
              </a>
            </li>
            <li>
              <a
                href="https://github.com/abhi-43"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-github fa-lg"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      
    </section>
  );
};

export default Home;
